import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DropdownModel } from '../../../models/component/dropdown.model';
import { CountryModel } from '../../../models/localization-and-pricing/country.model';

@Component({
  selector: 'app-evo-country-filter',
  templateUrl: './evo-country-filter.component.html',
  styleUrls: ['./evo-country-filter.component.css']
})
export class EvoCountryFilterComponent implements OnInit {

  /** Array of active country key strings. Empty array means "All countries". */
  @Input() selected: string[] = [];

  /**
   * When false (default), clicking a country replaces any existing selection (single-select).
   * When true, clicking toggles the country in or out of the selection (multi-select).
   */
  @Input() multiSelect = false;

  /** Shows the "All countries" pill. Turn it off when an empty selection is not a valid choice. */
  @Input() showAll = true;

  /** Overrides the countries offered, by default they are the ones for the current domain. */
  @Input() countries: string[] = null;

  @Output() selectedChange = new EventEmitter<string[]>();

  countryOptions: DropdownModel[] = [];

  ngOnInit() {
    let codes = CountryModel.countriesForCurrentDomain();
    if (this.countries) {
      codes = this.countries;
    }
    this.countryOptions = CountryModel.dropdownList(codes);
  }

  isAllActive(): boolean {
    return !this.selected || this.selected.length === 0;
  }

  isCountryActive(key: string): boolean {
    if (!this.selected) {
      return false;
    }
    return this.selected.indexOf(key) !== -1;
  }

  selectAll() {
    this.selectedChange.emit([]);
  }

  selectCountry(key: string) {
    if (this.multiSelect) {
      const updated: string[] = this.selected ? this.selected.slice() : [];
      const idx = updated.indexOf(key);
      if (idx !== -1) {
        updated.splice(idx, 1);
      } else {
        updated.push(key);
      }
      this.selectedChange.emit(updated);
    } else {
      this.selectedChange.emit([key]);
    }
  }
}
